import { GraphQLClient } from 'graphql-request';

export const client = new GraphQLClient(`${process.env.NEXT_PUBLIC_ENDPOINT}`, {
  headers: {
    'x-hasura-role': 'anonymous',
  },
});

export const clientAnonymous = new GraphQLClient(`${process.env.NEXT_PUBLIC_ENDPOINT}`, {
  headers: {
    'x-hasura-role': 'anonymous',
  },
});
export const fetcher = (query: any) => client.request(query);

export default GraphQLClient;
